import { staticPath } from "faqSrc/lib/$path";
import React, { VFC } from "react";
import ReactTooltip from "react-tooltip";
import styled, { createGlobalStyle } from "styled-components";
import Image from "~/components/atoms/Image";

interface TooltipButtonProps {
  text: string;
}

const TooltipButton: VFC<TooltipButtonProps> = ({ text }) => {
  return (
    <>
      <TooltipStyles />
      <HelpButton data-tip={text}>
        <Image
          src={staticPath.img.icon_help_web_svg}
          alt={text}
          height={18}
          width={18}
        />
      </HelpButton>
      <ReactTooltip />
    </>
  );
};

const TooltipStyles = createGlobalStyle`
  .__react_component_tooltip {
    font-size: 14px;
    line-height: 22px;
    max-width: 500px;
}
`;

const HelpButton = styled.div`
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
`;

export default TooltipButton;
